import EditPaymentManagerForm from './EditPaymentManagerForm';

export default EditPaymentManagerForm;
